import { format, parseISO } from "date-fns";
import { CalendarIcon, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const toDate = (value) => (value ? parseISO(value) : undefined);

const DateRangeFilter = ({ dateFrom, dateTo, onChange }) => {
  const selected = { from: toDate(dateFrom), to: toDate(dateTo) };
  const label = selected.from
    ? selected.to
      ? `${format(selected.from, "dd MMM yyyy")} – ${format(selected.to, "dd MMM yyyy")}`
      : `From ${format(selected.from, "dd MMM yyyy")}`
    : "Select date range";

  const handleSelect = (range) => {
    onChange({
      dateFrom: range?.from ? format(range.from, "yyyy-MM-dd") : "",
      dateTo: range?.to ? format(range.to, "yyyy-MM-dd") : "",
    });
  };

  return (
    <div className="flex items-center gap-1">
      <Popover>
        <PopoverTrigger asChild>
          <Button type="button" variant="outline" className="min-w-60 justify-start bg-white text-left font-normal">
            <CalendarIcon className="mr-2 h-4 w-4" />
            {label}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="range"
            selected={selected}
            onSelect={handleSelect}
            numberOfMonths={2}
            initialFocus
          />
        </PopoverContent>
      </Popover>
      {(dateFrom || dateTo) && (
        <Button type="button" variant="ghost" size="icon" onClick={() => onChange({ dateFrom: "", dateTo: "" })} aria-label="Clear date range">
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
};

export default DateRangeFilter;
